export { default } from './AssistantSlowWarning';
